module.exports = __webpack_public_path__ + "static/Touchless_MonthTwo-3-546f4927e197da228665d2d09a478a64.jpg";